module.exports = __webpack_public_path__ + "img/app/extApp/img/icon-arrow-click-lf.b7539320e1c99ec8cd8c678fbef84d49.png";